/**
 * ECONATION logo — reinterpretation of the original brand mark using the site palette
 * (energy green #10B981, deep green #064E3B, solar orange #F97316, charcoal #0F172A).
 *
 * variant: 'dark' (default — for white/light backgrounds)
 *          'light' (for dark backgrounds, hero, footer)
 * showTagline: include "ACTIVEZ VOTRE ÉNERGIE" sub-line
 */
export default function Logo({ variant = "dark", showTagline = false, className = "" }) {
  const isLight = variant === "light";
  const ecoColor = isLight ? "#34D399" : "#064E3B"; // bright emerald on dark bg, deep green on light bg
  const nationColor = isLight ? "#FFFFFF" : "#0F172A";
  const taglineColor = isLight ? "#10B981" : "#059669";

  return (
    <span className={`inline-flex items-center gap-3 select-none ${className}`} aria-label="ECONATION">
      {/* Icon: tilted solar panels + sun */}
      <svg viewBox="0 0 64 64" className="h-10 w-10 shrink-0" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="econ-sun" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#FB923C" />
            <stop offset="100%" stopColor="#F97316" />
          </linearGradient>
          <linearGradient id="econ-panel" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#34D399" />
            <stop offset="100%" stopColor="#10B981" />
          </linearGradient>
        </defs>
        {/* Sun behind */}
        <circle cx="44" cy="20" r="14" fill="url(#econ-sun)" />
        {/* Solar panels (skewed parallelogram split into a 3x2 cell grid) */}
        <g transform="translate(4, 22) skewX(-14)">
          <rect x="0" y="0" width="48" height="36" rx="3" fill="url(#econ-panel)" />
          {/* grid divisions */}
          <line x1="16" y1="0" x2="16" y2="36" stroke="#064E3B" strokeWidth="1.3" opacity="0.55" />
          <line x1="32" y1="0" x2="32" y2="36" stroke="#064E3B" strokeWidth="1.3" opacity="0.55" />
          <line x1="0" y1="18" x2="48" y2="18" stroke="#064E3B" strokeWidth="1.3" opacity="0.55" />
        </g>
      </svg>

      <span className="leading-none">
        <span className="block font-display font-bold tracking-[0.16em] text-[15px]">
          <span style={{ color: ecoColor }}>ECO</span>
          <span style={{ color: nationColor }}>NATION</span>
        </span>
        {showTagline ? (
          <span className="block text-[8.5px] tracking-[0.32em] uppercase mt-1.5 font-semibold" style={{ color: taglineColor }}>
            Activez votre énergie
          </span>
        ) : (
          <span className={`block text-[9px] tracking-[0.28em] uppercase mt-1.5 ${isLight ? "text-white/65" : "text-[#64748B]"}`}>
            Experts CEE · France
          </span>
        )}
      </span>
    </span>
  );
}
